import { Column, ColumnKeys } from './grid';
import { GridViewMetadata } from '../../../../grid/gridView/types';

export * from './grid';
export * from './deployer-relay-data';

export interface PackagesWebComponentSchema {
  viewMetaData: GridViewMetadata<Column, ColumnKeys>;
}

export interface Dependencies {
  api: {
    type: string;
    model: {
      ProtectedEntities: {
        getSuperAgents: Function;
        updateSupaMachines: Function;
      };
    };
  };
  translateFn: Function;
  getTimezone: Function;
  getUserLanguage: Function;
  getLanguages: Function;
  getCurrentUserCompany: Function;
  isCloud: Function;
  isGZ: Function;
  userHasFeature: Function;
  userHasRight: Function;
  permissions: Permissions;
}

export interface Permissions {
  canHaveChildCompanies: boolean;
}

export enum DeployerRelaysEndpointMethod {
  GET_SUPER_AGENTS = 'getSuperAgents',
  UPDATE_SUPA_MACHINES = 'updateSupaMachines',
  GET_UPDATE_SERVER_LOCATION = 'getUpdateServerLocation',
}

export enum DeployerGridEvents {
  ROW_SELECTED_EVENT = 'deployerGridRowSelected',
  RELAY_CHECKBOX_EVENT = 'relayCheckboxChange',
  CONNECT_TO_SELECTED_EVENT = 'connectToDeployerSelected',
}
